import axios from 'axios';
import {GlobalUtility} from '../../service/global-utility.service';
import {
  GET_USER_NOT_IN_MAILING,
  MAILING_RESOURCE,
  SEND_MAIL,
} from '../../service/constants.service';

const state = {
  mailingResources : [],
  mailingResource : {},
  usersMailingResource : [],
  newMailingResource : {
    userIds : [],
  },
};

const mutations = {
  set_mail: (state, params) => {
    state.crews = params;
  },

  set_mailing_resources  : (state,params) =>{
    state.mailingResources = params;
  },

  set_mailing_resource  : (state,params) =>{
    state.mailingResrouce = params;
  },

  //update

  //delete
  set_delete_mailing_resource : (state,params) =>{
    let index = state.mailingResources.findIndex((resource,index)=> resource.emailResourceId === params.id)
    state.mailingResources.splice(index,1);
  },

  set_null_mailingResources : (state) =>{
    state.mailingResources = [];
  },

  set_null_mailingResource : (state) =>{
    state.mailingResource = {};
  },

  set_user_mailing_resource : (state,params) =>{
    state.usersMailingResource = params;
  },

  //todo set null
  set_users_null_for_mailing_resource : (state) =>{
      state.usersMailingResource = [];
  },

  set_null_new_mailing_resource : (state) =>{
      state.newMailingResource = {
        userIds : [],
      }
  }
};

const actions = {
  async sendEmailCrewReservation({commit},params){
    return await axios.post(SEND_MAIL,params).then((response)=>{
      commit('set_mail',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.generateResponseMessage(error,'Mailing');
      GlobalUtility.failProgressBar();
      return false;
    });
  },

 async getMailingResources({commit},params) {
    return await axios.get(MAILING_RESOURCE).then((response)=>{
      commit('set_mailing_resources',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.generateResponseMessage(error,'Getting Mail Resource');
      return false;
    });
  },

  // getMailResource({commit},params){},

  createNewMailResource({commit},params){
    return axios.post(MAILING_RESOURCE,params).then((response)=>{
      return true;
    }).catch((error)=>{
      GlobalUtility.generateResponseMessage(error,'Create New Mail Resource');
      return false;
    });
  },

  updateMailResource({commit},params){
    return null;
  },

  deleteMailResource({commit}, params){
    return axios.delete(MAILING_RESOURCE).then((response)=>{

      return true;

    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Delete Mail Resource');
      return false;

    });
  },

  setNullMailResources({commit}){
    commit('set_null_mailingResources')
  },

  setNullMailResrouce({commit}){
    commit('set_null_mailingResource');
  },

 async getUsersNotInMailing({commit},params){
    return await axios.post(GET_USER_NOT_IN_MAILING,params).then((response)=>{
      commit('set_user_mailing_resource',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get Users Not In Mailing');
      return false;
    });
  },

  setNullUsersForMailingResource({commit}){
    commit('set_users_null_for_mailing_resource');
  },

  setNullMailingResource({commit}){
    commit('set_null_new_mailing_resource');
  },

  deleteMailResource({commit},params){
   return axios.delete(`${MAILING_RESOURCE}/${params}`).then((response)=>{
     commit('set_delete_mailing_resource',response.data);
     return true;
   }).catch((error)=>{
     GlobalUtility.failProgressBar();
     GlobalUtility.generateResponseMessage(error,'Delete Mail Resource');
     return false;
   });
  }
};

const getters =  {
  mailingResources : state => state.mailingResources,
  mailingResource : state => GlobalUtility.deCapitalizeProperties(state.mailingResource),
  newMailingResource : state => state.newMailingResource,

  //todo modify this for the mailing in case
  usersMailingResource : state => state.usersMailingResource,
}

export default {state,actions,mutations,getters};
